<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书  >  操作指南  >  证书信息登记   >  教育经历 </div>
    </div>
    <div class="auto padding250">
       <p class="title">教育经历</p>
      <div class="container ">
        <img src="../../assets/step1.png" alt="" style="display: none;">
        <img src="../../assets/step22.png" alt="" style="display: none;">
        <img src="../../assets/step21.png" alt="">
        <div class="formWrapper">
          <Form :label-width="105" label-position="right" class="formMin" >
            <FormItem label="最高学历 " class="txt-left">
                        <Select placeholder="请选择学历">
                            <Option value="">男</Option>
                            <Option value="">女</Option>

                        </Select>
                    </FormItem>
              <FormItem label="院校名称  ">
                <Input  value="" placeholder="请输入院校名称 " />
              </FormItem>

                      <FormItem label="在校生/已有学历  " class="txt-left">
                                  <Select placeholder="请选择在校生/已有学历 ">
                                      <Option value="">男</Option>
                                      <Option value="">女</Option>

                                  </Select>
                              </FormItem>
                              <FormItem label="证书编号/学籍号  ">
                                <Input  value="" placeholder="请选输入编号 " />
                              </FormItem>
              <FormItem label="毕业时间  " >
                <DatePicker class="dateRight" value="2018-09-06"  type="date" placeholder="请选择毕业时间 " style="width: 233px"></DatePicker>
              </FormItem>
              <FormItem label="所学专业   ">
                <Input  value="" placeholder="请输入所学专业 "/>
              </FormItem>
              <FormItem label="学制" class="txt-left">
                          <Select placeholder="请选择学制">
                              <Option value="">男</Option>
                              <Option value="">女</Option>

                          </Select>
                      </FormItem>
                      <FormItem label="学位 " class="txt-left">
                                  <Select placeholder="请选择学位">
                                      <Option value="">男</Option>
                                      <Option value="">女</Option>

                                  </Select>
                              </FormItem>
            <FormItem label=" " class="txt-left">
              <div class="keepThis"><router-link  to="/step2" class="keepBtn">下一步</router-link></div>
            </FormItem>
          </Form>

        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .formWrapper{
    width: 420px;
    padding: 40px 0 0 90px;
  }
  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
    }
    .container{
      background-color: #fff;
      padding: 50px 30px;
      margin-top: 10px;
      text-align: center;

      a{
        color: #fff;
        display: inline-block;
        width: 220px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #073C68;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'

    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changeScore/step1.vue